export default {
	VersionFeatures: [],
	Total: 0
};
